import Slider from "component/design-system/carousel/Slider";
import MediumVerticalProductCard from "../../components/product-cards/medium-vertical-product-card/MediumVerticalProductCard";
import styles from "./related-products.module.scss";

function RelatedProducts(props: any) {
  const { products, title = "Recommended Products" } = props;
  if (!products?.length) {
    return null;
  }
  return (
    <div className={styles.related_products_main}>

      <h2>{title}</h2>

      <Slider
        tileWidth={173}
        autoplay
        liClass={styles.slider_li_class}
      >
        {products.map((product: any) => (
          <MediumVerticalProductCard
            key={product.sku}
            product={product}
          />
        ))}
      </Slider>
    </div>
  );
}

export default RelatedProducts;
